import { render, staticRenderFns } from "./GiftDialog.vue?vue&type=template&id=4d2cc899&scoped=true&"
import script from "./GiftDialog.vue?vue&type=script&lang=js&"
export * from "./GiftDialog.vue?vue&type=script&lang=js&"
import style0 from "./GiftDialog.vue?vue&type=style&index=0&id=4d2cc899&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2cc899",
  null
  
)

export default component.exports